// Aroma y Momentos — JS autónomo de la página "Reserva de cumpleaños".

function cumpleInitReveal() {
  var els = document.querySelectorAll('.cumple-reveal:not(.cumple-visible)');
  els.forEach(function (el) { el.classList.add('cumple-visible'); });
}

function cumpleInitFormulario() {
  var forms = document.querySelectorAll('[data-cumple-form]');
  var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  forms.forEach(function (form) {
    var fecha = form.querySelector('[data-cumple-fecha]');
    var diaSemana = form.querySelector('[data-cumple-dia]');
    var ninos = form.querySelector('[data-cumple-ninos]');
    var ninosProp = form.querySelector('[data-cumple-ninos-prop]');
    var totalEl = form.querySelector('[data-cumple-total]');
    var pack = form.querySelector('[data-cumple-pack]');
    var bocadillos = form.querySelector('[data-cumple-bocadillos]');
    var bocadilloSelects = bocadillos ? bocadillos.querySelectorAll('select') : [];
    var soloCompleto = form.querySelector('[data-cumple-solo-completo]');
    var soloCompletoCampos = soloCompleto ? soloCompleto.querySelectorAll('input, select, textarea') : [];
    var manualidad = form.querySelector('[data-cumple-manualidad]');
    var soloPintura = form.querySelector('[data-cumple-solo-pintura]');
    var pinturaRadios = soloPintura ? soloPintura.querySelectorAll('input[type="radio"]') : [];
    var soloVela = form.querySelector('[data-cumple-solo-vela]');
    var velaRadios = soloVela ? soloVela.querySelectorAll('input[type="radio"]') : [];
    var soloLibretas = form.querySelector('[data-cumple-solo-libretas]');
    var formaPagoRadios = form.querySelectorAll('[data-cumple-forma-pago]');
    var notaEfectivo = form.querySelector('[data-cumple-nota-efectivo]');
    var notaResto = form.querySelector('[data-cumple-nota-resto]');
    var notaAntesPago = form.querySelector('[data-cumple-nota-antes-pago]');
    var totalEtiqueta = form.querySelector('[data-cumple-total-etiqueta]');
    var confirmacion = form.querySelector('[data-cumple-confirmacion]');
    var boton = form.querySelector('[data-cumple-comprar]');
    var variantIdInput = form.querySelector('[data-cumple-variant-id]');
    var variantesEl = form.querySelector('[data-cumple-variantes-json]');
    var variantes = null;
    if (variantesEl) {
      try { variantes = JSON.parse(variantesEl.textContent); } catch (e) { variantes = null; }
    }

    function velaCristalSeleccionada() {
      var marcada = null;
      velaRadios.forEach(function (r) { if (r.checked) marcada = r; });
      return !!marcada && /cristal/i.test(marcada.value);
    }

    function pagaEnEfectivo() {
      var marcada = null;
      formaPagoRadios.forEach(function (r) { if (r.checked) marcada = r; });
      return !!marcada && marcada.getAttribute('data-cumple-forma-pago') === 'efectivo';
    }

    function actualizarDia() {
      if (!fecha || !diaSemana) return;
      if (!fecha.value) { diaSemana.value = ''; return; }
      var partes = fecha.value.split('-');
      var d = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]));
      if (isNaN(d.getTime())) { diaSemana.value = ''; return; }
      var nombre = dias[d.getDay()];
      diaSemana.value = nombre.charAt(0).toUpperCase() + nombre.slice(1);
    }

    function actualizarTotal() {
      if (!ninos || !totalEl) return;
      var n = Math.max(0, parseInt(ninos.value, 10) || 0);
      var esCristal = velaCristalSeleccionada();
      var esEfectivo = pagaEnEfectivo();
      var precioBase = variantes ? (variantes.base.precio / 100) : 5;
      var precioCristal = variantes ? (variantes.cristal.precio / 100) : 10;
      var precioUnidad = esEfectivo ? 0 : (esCristal ? precioCristal : precioBase);
      var total = n * precioUnidad;
      totalEl.textContent = total.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
      if (ninosProp) ninosProp.value = n;
      if (variantIdInput && variantes) {
        variantIdInput.value = esEfectivo ? variantes.efectivo.id : (esCristal ? variantes.cristal.id : variantes.base.id);
      }
      if (totalEtiqueta) {
        totalEtiqueta.textContent = esEfectivo ? 'Total a pagar hoy' : 'Paga y señal a realizar hoy';
      }
      if (notaEfectivo) notaEfectivo.hidden = !esEfectivo;
      if (notaResto) notaResto.hidden = esEfectivo;
      if (notaAntesPago) notaAntesPago.hidden = esEfectivo;
    }

    function actualizarPack() {
      if (!pack) return;
      var esCompleto = pack.value === 'Pack Completo';
      if (bocadillos) {
        bocadillos.hidden = !esCompleto;
        bocadilloSelects.forEach(function (s) {
          s.required = esCompleto;
          if (!esCompleto) s.value = '';
        });
      }
      if (soloCompleto) {
        soloCompleto.hidden = !esCompleto;
        if (!esCompleto) {
          soloCompletoCampos.forEach(function (c) { c.value = ''; });
        }
      }
    }

    function actualizarBoton() {
      if (!confirmacion || !boton) return;
      boton.disabled = !confirmacion.checked;
    }

    function actualizarGrupoOpciones(radios, activo) {
      radios.forEach(function (r) {
        r.required = activo;
        if (!activo) {
          r.checked = false;
          var card = r.closest('.cumple-opcion-card');
          if (card) card.classList.remove('cumple-opcion-card--activa');
        }
      });
    }

    function actualizarManualidad() {
      if (!manualidad) return;
      var esPintura = manualidad.value === 'Pintura';
      var esVela = manualidad.value === 'Taller de vela';
      var esLibretas = manualidad.value === 'Libretas de scrap';
      if (soloPintura) { soloPintura.hidden = !esPintura; actualizarGrupoOpciones(pinturaRadios, esPintura); }
      if (soloVela) { soloVela.hidden = !esVela; actualizarGrupoOpciones(velaRadios, esVela); }
      if (soloLibretas) { soloLibretas.hidden = !esLibretas; }
      actualizarTotal();
    }

    pinturaRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        pinturaRadios.forEach(function (o) {
          var card = o.closest('.cumple-opcion-card');
          if (card) card.classList.toggle('cumple-opcion-card--activa', o.checked);
        });
      });
    });

    velaRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        velaRadios.forEach(function (o) {
          var card = o.closest('.cumple-opcion-card');
          if (card) card.classList.toggle('cumple-opcion-card--activa', o.checked);
        });
        actualizarTotal();
      });
    });

    formaPagoRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        formaPagoRadios.forEach(function (o) {
          var card = o.closest('.cumple-opcion-card');
          if (card) card.classList.toggle('cumple-opcion-card--activa', o.checked);
        });
        actualizarTotal();
      });
    });

    if (fecha) { fecha.addEventListener('change', actualizarDia); actualizarDia(); }
    if (ninos) { ninos.addEventListener('input', actualizarTotal); actualizarTotal(); }
    if (pack) { pack.addEventListener('change', actualizarPack); actualizarPack(); }
    if (confirmacion) { confirmacion.addEventListener('change', actualizarBoton); actualizarBoton(); }
    if (manualidad) { manualidad.addEventListener('change', actualizarManualidad); actualizarManualidad(); }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  cumpleInitReveal();
  cumpleInitFormulario();
});
